import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { ReportsRoleAssignmentsSchema } from "@/lib/data/schemas/reports/ReportsSchema";
import type {
  APIResponse,
  ReportsRoleAssignmentRow,
  ReportsRoleAssignmentStatus,
  ReportsRoleAssignments,
  MatterRole,
} from "@/lib/types";

type RoleAssignmentsApiData = {
  role: { id: string; label: string };
  statuses: ReportsRoleAssignmentStatus[];
  metrics: { totalUsers: number; totalAssignments: number };
  rows: ReportsRoleAssignmentRow[];
};

type RoleAssignmentsApiResponse = Omit<
  APIResponse<RoleAssignmentsApiData>,
  "pagination"
> & {
  pagination?: { hasMore?: boolean };
};

export const retrieveRoleAssignmentReportRoles = async () => {
  const response = await authenticatedFastApiAxiosInstance.get<
    APIResponse<MatterRole[]>
  >("matters/v2/settings", { params: { module: "roles" } });
  return { data: response.data.data };
};

export const retrieveReportsRoleAssignments = async (roleId: string) => {
  const rows: ReportsRoleAssignmentRow[] = [];
  let pageNumber = 1;
  let firstPage: RoleAssignmentsApiData | undefined;
  let hasMore = false;

  do {
    const response =
      await authenticatedFastApiAxiosInstance.post<RoleAssignmentsApiResponse>(
        "reports/v2/role-assignments/query",
        {
          filters: { roleId },
          pageNumber,
          pageSize: 250,
        },
      );
    firstPage ??= response.data.data;
    rows.push(...response.data.data.rows);
    hasMore = response.data.pagination?.hasMore === true;
    pageNumber += 1;
  } while (hasMore && pageNumber <= 1000);

  const data = ReportsRoleAssignmentsSchema.parse({
    ...firstPage,
    rows,
  }) satisfies ReportsRoleAssignments;

  return { data };
};
